import { render } from "./ArchivedOrderIsland.vue?vue&type=template&id=c7849afc"
import script from "./ArchivedOrderIsland.vue?vue&type=script&lang=js"
export * from "./ArchivedOrderIsland.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__